import { Link, useLocation } from "react-router-dom";
import { Home, Package, Calendar } from "lucide-react";

export default function Navigation() {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-white border-b border-zinc-200 sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-10 h-10 bg-gradient-to-br from-zinc-900 to-zinc-700 rounded-lg flex items-center justify-center">
              <Package className="text-white" size={20} />
            </div>
            <span className="text-xl font-bold text-zinc-900">Sahar Storage</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg font-medium transition flex items-center gap-2 ${
                isActive("/")
                  ? "bg-zinc-900 text-white"
                  : "text-zinc-600 hover:bg-zinc-100"
              }`}
            >
              <Home size={18} />
              Home
            </Link>
            <Link
              to="/containers"
              className={`px-4 py-2 rounded-lg font-medium transition flex items-center gap-2 ${
                isActive("/containers")
                  ? "bg-zinc-900 text-white"
                  : "text-zinc-600 hover:bg-zinc-100"
              }`}
            >
              <Package size={18} />
              Containers
            </Link>
            <Link
              to="/booking"
              className={`px-4 py-2 rounded-lg font-medium transition flex items-center gap-2 ${
                isActive("/booking")
                  ? "bg-zinc-900 text-white"
                  : "text-zinc-600 hover:bg-zinc-100"
              }`}
            >
              <Calendar size={18} />
              Book Now
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <Link
              to="/booking"
              className="px-4 py-2 bg-zinc-900 text-white rounded-lg font-medium text-sm"
            >
              Book
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
